import React from 'react';

const MissionStatement = () => {
  return (
    <div className="container py-8">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-3xl font-semibold mb-6">Mission Statement</h1>
        
        <div className="prose max-w-none">
          <section className="mb-8">
            <p className="mb-6 text-lg">
              The mission of Hamilton College of the Bahamas is to provide the educational 
              experience in an environment supportive of faith and learning that will encourage 
              adult students to "discover their potential." Hamilton College makes high-quality, 
              professionally enhanced programs accessible to adults of diverse backgrounds and 
              assists them to succeed in their careers and communities. Hamilton College of the 
              Bahamas is Christian and evangelical in nature. However, many students at Hamilton 
              College are not Christians. Students are admitted without consideration to race, 
              color, national origin, sex, or religion. All are encouraged to be faithful to 
              their faith.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">Core Values</h2>
            
            <div className="grid gap-6 md:grid-cols-2">
              <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-100">
                <h3 className="font-semibold text-lg mb-2">Academic Quality</h3>
                <p>We are committed to effective adult learning and rigorous academic standards.</p>
              </div>

              <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-100">
                <h3 className="font-semibold text-lg mb-2">Student Success</h3>
                <p>We provide the opportunity and supportive learning environment that enables adults to achieve their professional and personal goals.</p>
              </div>

              <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-100">
                <h3 className="font-semibold text-lg mb-2">Educational Access</h3>
                <p>We believe all desiring and qualified adults have a right to higher education.</p>
              </div>

              <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-100">
                <h3 className="font-semibold text-lg mb-2">Private and Non-governmental</h3>
                <p>Hamilton College of the Bahamas is a private and non-governmental institution.</p>
              </div>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">Religious Emphasis</h2>
            <p className="mb-4">
              We believe that secular and religious instructions should be available to everyone 
              in their studies to include:
            </p>
            
            <ul className="space-y-4 ml-6">
              <li className="flex items-start">
                <span className="mr-2 mt-1.5">•</span>
                <span>Challenging students to respond to the spiritual and social needs of the community and world</span>
              </li>
              <li className="flex items-start">
                <span className="mr-2 mt-1.5">•</span>
                <span>Providing a solid core of academic studies within the theological, counseling, and business disciplines</span>
              </li>
              <li className="flex items-start">
                <span className="mr-2 mt-1.5">•</span>
                <span>Engaging students in religious experimental learning and integrative academic reflection</span>
              </li>
              <li className="flex items-start">
                <span className="mr-2 mt-1.5">•</span>
                <span>Promote evangelical Christianity from a Wesleyan perspective</span>
              </li>
            </ul>
          </section>
        </div>
      </div>
    </div>
  );
};

export default MissionStatement; 